import React, { Component } from 'react';



class Footer extends Component {
  constructor(props){
      super(props);
   }
  render() {

    return (
      <footer className="App-footer">
        <div className="smoke-container">
          <div className="smokes">
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
          </div>
          <div className="smokes">
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
          </div>
          <div className="smokes">
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
            <span className="smoke"></span>
          </div>
        </div>

        <div className="ground">
        </div>
        <div className="container section">
          <p className="paragraph copyright">Made with <span>&hearts;</span> by <a className="link credit-link" ref="external" target="_blank" href="https://www.instagram.com/lingdraws/">Xindeling Pan</a> and <a className="link credit-link" href="mailto:jqpeng1995@gmail.com?Subject=Hello">Jenny Peng</a> | Last updated: June 2022</p>
        </div>

      </footer>
    )
  }
}

export default Footer;
